import styles from './MobileBurger.module.scss';

const MobileBurger = (): JSX.Element => {
  return <div data-testid="mobile-burger" className={styles.mobileBurger} />;
};

export default MobileBurger;
